import { IChangeRequestStatusResult } from '../types/changeRequestStatusResult'

export class ChangeRequestStatusResult implements IChangeRequestStatusResult
{
    customerChangeRequestFound: boolean = false
    referenceNumber: string = ''
    customerChangeRequestTypeId: number = undefined
	customerChangeRequestState: string = ''
	statusDate: Date = undefined
    customerNote: string = ''
}